/** @prettier */
import React from "react";
import { ListGroupItemProps, ListGroupItem } from "react-bootstrap";
import { useHistory } from "react-router-dom";

export type ListGroupLinkItemProps = Omit<ListGroupItemProps, "onClick"> & {
    // Make href mandatory
    href: string;
};
/**
 * Thin wrapper around ListGroupItem that handles linking behavior with react-router.
 * The preferred behavior is to use the history object to route without a reload
 * But exposes href for normal link behavior like "open in new tab"
 **/
const ListGroupLinkItem = ({
    href,
    disabled,
    ...props
}: ListGroupLinkItemProps) => {
    const history = useHistory();
    return (
        <ListGroupItem
            onClick={(e) => {
                e.preventDefault();
                if (!disabled) {
                    history.push(href);
                }
            }}
            href={href}
            {...props}
        />
    );
};

export default ListGroupLinkItem;
